export default __webpack_public_path__ + "static/screenshot_2-e3c71611004bb96c996000198dbf6bb3.png";